import React, { useState } from 'react';
import FormSelector from './FormSelector';
import { BEAM_FORM_COMPONENTS } from '../Constants/Constants';

const OldDashboard = () => {
  const [selectedForm, setSelectedForm] = useState('');

  return (
    <div className='csm-container'>
      <div className='box w-full'>
        <h1 className='my-5 text-center text-3xl font-semibold '>CSM-Dashboard</h1>
        <div style={{ textAlign: 'center' }}>
          <FormSelector onChange={setSelectedForm} />
          {BEAM_FORM_COMPONENTS[selectedForm] ?? null}
        </div>
      </div>
    </div>
  );
};

export default OldDashboard;
